import { render, staticRenderFns } from "./register-godson.vue?vue&type=template&id=fa660e86&scoped=true&"
import script from "./register-godson.vue?vue&type=script&lang=js&"
export * from "./register-godson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa660e86",
  null
  
)

export default component.exports